import { useQuery } from '@tanstack/react-query'
import { transactionsAPI } from '../services/api'

export const useTransactions = ({ 
  search = '', 
  filters = {}, 
  page = 1, 
  limit = 25 
} = {}) => {
  return useQuery({
    queryKey: ['admin', 'transactions', { search, filters, page, limit }],
    queryFn: async () => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      })

      if (search.trim()) {
        params.append('search', search.trim())
      }

      // Type filter
      if (filters.type && filters.type !== 'all') {
        params.append('type', filters.type)
      }

      // Status filter
      if (filters.status && filters.status !== 'all') {
        params.append('status', filters.status)
      }

      // Amount range filter
      if (filters.amountRange && Array.isArray(filters.amountRange)) {
        if (filters.amountRange[0] !== 0) {
          params.append('amountMin', filters.amountRange[0].toString())
        }
        if (filters.amountRange[1] !== 1000) {
          params.append('amountMax', filters.amountRange[1].toString())
        }
      }

      // Date range filter
      if (filters.dateRange) {
        if (filters.dateRange.startDate) {
          params.append('dateFrom', filters.dateRange.startDate.toISOString().split('T')[0])
        }
        if (filters.dateRange.endDate) {
          params.append('dateTo', filters.dateRange.endDate.toISOString().split('T')[0])
        }
      }

      // Sorting
      if (filters.sortBy) {
        params.append('sortBy', filters.sortBy)
      }
      if (filters.sortOrder) {
        params.append('sortOrder', filters.sortOrder)
      }

      const response = await transactionsAPI.getTransactions(Object.fromEntries(params))
      return response.data.data
    },
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  })
}

export const useTransactionStats = (filters = {}) => {
  return useQuery({
    queryKey: ['admin', 'transactions', 'stats', filters],
    queryFn: async () => {
      const params = new URLSearchParams()
      
      // Apply same filters as main query for consistent stats
      if (filters.type && filters.type !== 'all') {
        params.append('type', filters.type)
      }
      if (filters.status && filters.status !== 'all') {
        params.append('status', filters.status)
      }
      if (filters.dateRange) {
        if (filters.dateRange.startDate) {
          params.append('dateFrom', filters.dateRange.startDate.toISOString().split('T')[0])
        }
        if (filters.dateRange.endDate) {
          params.append('dateTo', filters.dateRange.endDate.toISOString().split('T')[0])
        }
      }
      
      const response = await transactionsAPI.getTransactions({ page: 1, limit: 1, ...Object.fromEntries(params) })
      return response.data.stats
    },
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
  })
}